import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useAuth } from '@/features/auth'
import { MainLayout } from '@/components/layout'
import { ShieldAlert } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/admin')({
  component: AdminLayout,
})

function AdminLayout() {
  const { isAdmin } = useAuth()

  if (!isAdmin) {
    return (
      <MainLayout title="Acesso negado" subtitle="Você não tem permissão para acessar esta área">
        <div className="card p-12 text-center">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-red-100 rounded-full mb-4">
            <ShieldAlert className="h-6 w-6 text-red-600" />
          </div>
          <p className="text-gray-600 font-medium">
            Você não tem permissão para acessar esta página
          </p>
          <p className="text-sm text-gray-500 mt-1">
            Entre em contato com o administrador
          </p>
        </div>
      </MainLayout>
    )
  }

  return <Outlet />
}
